import { loadModules } from 'esri-loader';
import { SYMBOL_TYPE, GEOMETRY_TYPE, EsriSymbol, SR_WKID } from 'types';

export const convertCoordsXYToLatLng = async (coordinates: number[][]) => {
  const [Point, SpatialReference] = await loadModules([
    'esri/geometry/Point',
    'esri/geometry/SpatialReference'
  ]);

  return coordinates
    .map(
      ([x, y]) =>
        new Point({
          x,
          y,
          spatialReference: new SpatialReference({ wkid: SR_WKID.WEB_MERCATOR })
        })
    )
    .map(({ latitude, longitude }) => [latitude, longitude]);
};

export const getSymbolForGeometry = (
  type: GEOMETRY_TYPE | string
): EsriSymbol => {
  switch (type) {
    case GEOMETRY_TYPE.POLYGON:
      return {
        type: SYMBOL_TYPE.FILL,
        color: [255, 255, 255, 0.8],
        outline: {
          color: [255, 0, 0],
          width: 2
        }
      };
    default:
      return {
        type: SYMBOL_TYPE.MARKER,
        color: [255, 255, 255, 0.8]
      };
  }
};
